import PropTypes from "prop-types";
import ProductCards from "containers/ProductCards";
import breakPoints from "helpers/Styles";
import { StorefrontContext } from "providers/storefront";
import { useContext } from "react";

const GamingProductList = ({
  data,
  features,
  buttonLabel,
  fixedPrice,
  readyToShip,
  index,
}) => {
  const { isAnnouncementBarOpen } = useContext(StorefrontContext);

  if (!data) return "";
  const { items: products, primary: info } = data;
  if (!readyToShip && features?.length) {
    products.forEach((product) => {
      product.featureDoc = features.find(
        (feature) => feature.id === product.features.id
      );
    });
  }

  return (
    <div className={`gaming_product_list_container `}>
      <div className="gaming_product_list">
        <div className="products_info">
          <div className="info">
            <div className="info_data">
              <div className="info_header">{info.product_title}</div>
              <div className="info_keywords">{info.product_keywords}</div>
            </div>
            {info?.product_description?.[0]?.text && (
              <div className="info_description">
                {info.product_description[0].text}
              </div>
            )}
          </div>
          <div className="products">
            <ProductCards
              products={products}
              buttonLabel={buttonLabel}
              fixedPrice={fixedPrice}
              readyToShip={readyToShip}
            />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .gaming_product_list_container {
            padding: ${index === 0 && isAnnouncementBarOpen === false
              ? '90px 0px 60px 0px'
              : '60px 0 '};
            background-color: #000000;
          }
          .gaming_product_list {
            display: flex;
          }
          .products_info {
            display: flex;
            flex-direction: column;
            gap: 32px;
          }
          .info {
            display: flex;
            gap: 32px;
          }
          .info_data {
            flex: 1;
            display: flex;
            flex-direction: column;
          }
          .info_header {
            color: #e4e4e4;
            font-family: 'big_noodle_titling';
            font-size: 31px;
            letter-spacing: 0;
            line-height: 40px;
          }
          .info_keywords {
            color: #949494;
            font-family: 'big_noodle_titling';
            font-size: 20px;
            letter-spacing: 0;
            line-height: 24px;
          }
          .info_description {
            flex: 2;
            color: #e4e4e4;
            font-family: 'Roboto-Light';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
          }
          .products {
            display: flex;
            padding: 20px 0px;
          }
          @media (max-width: ${breakPoints.medium}) {
            .gaming_product_list_container {
              padding-top: 10px;
              padding-bottom: 30px;
            }
            .gaming_product_list {
              //flex-wrap: wrap;
              display: block;
            }
            .products_info {
              //flex-wrap: wrap;
              //width: 90px;
            }
            .info {
              display: block;
              //width: 90%;
            }
            .info_data {
              max-width: 100%;
            }
            .info_description {
              padding-top: 10px;
              width: 100%;
            }
            .gaming_product_list {
              flex-wrap: wrap;
            }
            .products {
              display: block;
            }
          }
        `}
      </style>
    </div>
  );
};

GamingProductList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  features: PropTypes.arrayOf(PropTypes.object),
  buttonLabel: PropTypes.string,
  fixedPrice: PropTypes.bool,
  readyToShip: PropTypes.bool,
};

GamingProductList.defaultProps = {
  features: null,
  buttonLabel: null,
  fixedPrice: false,
  readyToShip: false,
};

export default GamingProductList;
